export default __webpack_public_path__ + "static/media/DOT.4345f3e4.svg";